import React, { useEffect, useState } from "react";
import { resolveMediaUrl, handleMediaImgError } from "../Helper/mediaUrl";
import { fetchCommunityPrayerTypes } from "./communitySocialApi";

/**
 * Pray dialog — loads Prayer Types from Admin canonical configuration.
 * No hardcoded type names.
 */
function PrayerTypeDialog({
  open = false,
  onClose = null,
  onSelect = null,
  activeTypeId = null,
  busy = false,
}) {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setLoading(true);
    setError("");
    fetchCommunityPrayerTypes().then((res) => {
      if (cancelled) return;
      setLoading(false);
      if (res.error) {
        setError(res.message || "Unable to load Prayer Types");
        setTypes([]);
        return;
      }
      setTypes(Array.isArray(res.prayer_types) ? res.prayer_types : []);
    });
    return () => {
      cancelled = true;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="community-prayer-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="community-prayer-dialog-title"
    >
      <div className="community-prayer-dialog__backdrop" onClick={onClose} />
      <div className="community-prayer-dialog__panel">
        <header className="community-prayer-dialog__head">
          <h3 id="community-prayer-dialog-title">How will you pray?</h3>
          <button
            type="button"
            className="community-prayer-dialog__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </header>
        {loading ? (
          <p className="community-create-post__hint">Loading Prayer Types…</p>
        ) : null}
        {error ? (
          <p className="community-create-post__error" role="alert">
            {error}
          </p>
        ) : null}
        {!loading && !error && !types.length ? (
          <p className="community-create-post__hint">
            No Prayer Types are configured yet. Ask an administrator to add them.
          </p>
        ) : null}
        <ul className="community-prayer-dialog__list">
          {types.map((type) => {
            const active = activeTypeId != null && Number(activeTypeId) === Number(type.id);
            const img = type.image || type.image_path;
            return (
              <li key={type.id}>
                <button
                  type="button"
                  className={
                    "community-prayer-dialog__option" + (active ? " is-active" : "")
                  }
                  disabled={busy}
                  onClick={() => {
                    if (typeof onSelect === "function") onSelect(type);
                  }}
                >
                  {img ? (
                    <img
                      src={resolveMediaUrl(img)}
                      alt=""
                      onError={handleMediaImgError}
                    />
                  ) : (
                    <span className="community-prayer-dialog__icon" aria-hidden="true">
                      ✝
                    </span>
                  )}
                  <span>{type.name}</span>
                </button>
              </li>
            );
          })}
        </ul>
        {activeTypeId ? (
          <button
            type="button"
            className="community-prayer-dialog__clear"
            disabled={busy}
            onClick={() => {
              if (typeof onSelect === "function") onSelect(null);
            }}
          >
            Remove prayer commitment
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default PrayerTypeDialog;
